import { getConditionalObject } from 'utils/data';

import { getBorrowerFieldName } from './constants';

export const getInitialFormValues = ({ editData, denialReasonOptions, borrowerOptions }) => {
  const nameOption = denialReasonOptions.find(({ value }) => editData.id === value);

  return {
    name: nameOption,
    HMDACode: editData.HMDACode,
    isDenialDueToCredit: editData.isDenialDueToCredit,
    isAffiliate: editData.isAffiliate,
    ...getConditionalObject(editData.isDenialDueToCredit, () =>
      borrowerOptions.reduce((acc, curr, i) => {
        acc[getBorrowerFieldName(i)] = editData.selectedBorrowers?.includes(curr.value);

        return acc;
      }, {}),
    ),
  };
};
